export type EditorUGCTokens = {
	'editor.font.heading.h1': string;
	'editor.font.heading.h2': string;
	'editor.font.heading.h3': string;
	'editor.font.heading.h4': string;
	'editor.font.heading.h5': string;
	'editor.font.heading.h6': string;
	'editor.font.weight.heading.h1.bold': string;
	'editor.font.weight.heading.h2.bold': string;
	'editor.font.weight.heading.h3.bold': string;
	'editor.font.weight.heading.h4.bold': string;
	'editor.font.weight.heading.h5.bold': string;
	'editor.font.weight.heading.h6.bold': string;
	'editor.font.body': string;
};

export const editorUGCTokens: EditorUGCTokens = {
	'editor.font.heading.h1':
		'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h2':
		'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h3':
		'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h4':
		'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h5':
		'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h6':
		'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.body':
		'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.weight.heading.h1.bold': '700',
	'editor.font.weight.heading.h2.bold': '700',
	'editor.font.weight.heading.h3.bold': '700',
	'editor.font.weight.heading.h4.bold': '700',
	'editor.font.weight.heading.h5.bold': '700',
	'editor.font.weight.heading.h6.bold': '700',
};

export const editorUGCTokensModernized: EditorUGCTokens = {
	'editor.font.heading.h1':
		'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h2':
		'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h3':
		'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h4':
		'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h5':
		'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h6':
		'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.body':
		'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.weight.heading.h1.bold': '700',
	'editor.font.weight.heading.h2.bold': '700',
	'editor.font.weight.heading.h3.bold': '700',
	'editor.font.weight.heading.h4.bold': '700',
	'editor.font.weight.heading.h5.bold': '700',
	'editor.font.weight.heading.h6.bold': '700',
};

export const editorUGCTokensRefreshed: EditorUGCTokens = {
	'editor.font.heading.h1':
		'normal 600 1.71429em/1.16667 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h2':
		'normal 600 1.42857em/1.2 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h3':
		'normal 600 1.14286em/1.25 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h4':
		'normal 600 1em/1.14286 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h5':
		'normal 600 0.857143em/1.33333  "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.heading.h6':
		'normal 600 0.785714em/1.45455 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.body':
		'normal 400 1em/1.714 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
	'editor.font.weight.heading.h1.bold': '700',
	'editor.font.weight.heading.h2.bold': '700',
	'editor.font.weight.heading.h3.bold': '700',
	'editor.font.weight.heading.h4.bold': '700',
	'editor.font.weight.heading.h5.bold': '700',
	'editor.font.weight.heading.h6.bold': '700',
};
